import React, { memo } from 'react';
import useTheme from '@hooks/useTheme';
import { ThemeType } from '@model';

function ThemeImg({ darkSrc, lightSrc, ...props }) {
  const { theme } = useTheme();
  return <img src={theme === ThemeType.dark ? darkSrc : lightSrc} {...props} />;
}

export default memo(ThemeImg);
